import { z } from 'zod'

export const MEMBERSHIP_HEALTH_CONTRACT_VERSION = '1.0.0' as const

export const membershipHealthResponseSchema = z.object({
  ok: z.boolean(),
  status: z.string(),
  service: z.string(),
  version: z.string(),
  contract_version: z.string(),
  mode: z.string(),
  uptime_s: z.number(),
}).passthrough()

export type MembershipHealthResponse = z.infer<typeof membershipHealthResponseSchema>
